import React, {useCallback} from "react";

import { useApolloClient } from "@apollo/client";
import { 
  Control, 
  Controller, 
} from "react-hook-form";
import { 
  GetUsersMinimalDocument, 
  ReviewFullFragment, 
  UserMinimalFragment, 
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import AsyncSelect from "../../utils/chakra/AsyncSelect";

type ReviewReferentsFormType = {
  control: Control<Record<string, any>>;
  defaultValues: ReviewFullFragment;
}

const ReviewReferentsForm : React.FC<ReviewReferentsFormType> = ({
  control,
  defaultValues
}) => {
  const client = useApolloClient();
  const t = useTranslations();
  
  const getUsers = useCallback(
    async (variables) => {
      const usersData = await client.query({
        query: GetUsersMinimalDocument,
        variables
      });

      return (
        usersData.data?.users.collection as UserMinimalFragment[]).map(({ name: label, id: value }) => (
          { label, value }
        )
      );
    },
    [client]
  );

  const getAllUsers = useCallback(() => (
    getUsers({ q: "" })
  ), [getUsers]);
  
  const searchUsers = useCallback((q) => (
    getUsers({ q, per: 20 })
  ), [getUsers]);

  return(
    <Controller
      control={control}
      name="referentIds"
      defaultValue={defaultValues?.referentIds}
      rules={{ required: false }}
      render={({ onChange, ref, onBlur, value }) => (
        <AsyncSelect
          id="select-mission-referents"
          inputRef={ref}
          isMultiple
          placeholder={t("reviews.searchReferents") as string}
          options={searchUsers}
          onChange={(value) => {
            onChange(value.map((item) => item.value))
          }}
          onBlur={onBlur}
          allOptions={getAllUsers}
          canSelectAll
          selectAllLabel={
            t("reviews.selectAllReferents") as string
          }
          defaultValues={value}
        />
      )}
    />
  )
};

export default React.memo(ReviewReferentsForm);